import React, { Suspense } from 'react';
import Loading from '../global/loading';

const isSSR = typeof window === "undefined";

const IntroText = props => (
	<>
	{!isSSR && (
	<Suspense fallback={<Loading/>}>
		<div className={`typeFonts1 typeColorDark1 text-block page-block intro-text`}>
			<p className="intro"
				dangerouslySetInnerHTML={{ __html: props.text }}
			/>
		</div>
	</Suspense>
	)}
    </>
);

export default IntroText;
